module.exports = "/_next/static/images/row3-1-2x-51b279a888f400b53e331b576bd638ad.png";